import React,{cloneElement,isValidElement,useEffect} from 'react';
import {useLocation} from 'react-router-dom';
import {setRuntimeLanguage,currentLanguage} from './runtime';
export function LocaleBridge({language: accountLanguage, children}) {
  const location = useLocation();
  let accessLanguage;
  try { accessLanguage = localStorage.getItem('ea_access_language'); } catch (_) {}
  setRuntimeLanguage(accountLanguage || new URLSearchParams(location.search).get('lang') || accessLanguage);
  const code=currentLanguage();
  useEffect(()=>{document.documentElement.lang=code;},[code]);
  return isValidElement(children) ? cloneElement(children, {}) : children;
}
